import { createContext } from 'react'
//All Auction details
const auctionContext = createContext()

export default auctionContext
